// extracted by mini-css-extract-plugin
module.exports = {"slider":"stepone-module__sL89FG__slider","slick-list":"stepone-module__sL89FG__slick-list"};